module.exports = __webpack_public_path__ + "static/fonts/luengo-ultralight-webfont.db47a6d2.woff2";